import React from 'react';
import PropTypes from 'prop-types';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';

import {
    Button,
    ButtonGroup,
    Flex,
    Spacer,
    TextButton,
    Text,
} from '@zillow/constellation';

const propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    cancelText: PropTypes.string,
    errorMessage: PropTypes.string,
    isSubmitting: PropTypes.bool,
    hasError: PropTypes.bool,
};

const defaultProps = {
    onCancel: null,
    submitText: 'Confirm',
    cancelText: 'Cancel',
    errorMessage: '',
    isSubmitting: false,
    hasError: false,
};

const ModalFooter = ({
    onCancel,
    onSubmit,
    submitText,
    cancelText,
    errorMessage,
    isSubmitting,
    hasError,
}) => (
    <Flex display="flex" flexDirection="column" alignItems="flex-end">
        {hasError && (
            <Spacer paddingBottom="xs">
                <Text fontColor="red600">{errorMessage || ErrorMessageConstants.DEFAULT_ERROR}</Text>
            </Spacer>
        )}
        <ButtonGroup>
            {onCancel && (
                <TextButton
                    buttonType="primary"
                    onClick={onCancel}
                    disabled={isSubmitting}
                >
                    {cancelText}
                </TextButton>
            )}
            <Button
                buttonType="primary"
                onClick={onSubmit}
                disabled={isSubmitting}
            >
                {submitText}
            </Button>
        </ButtonGroup>
    </Flex>
);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

export default ModalFooter;
